import { Avatar, ChildMark } from "../components/Common.jsx";
import { cardGradientStyle, getKidTheme } from "../lib/utils.js";
import { effectiveAge } from "../lib/age.js";
import { t as ct } from "../lib/content.js";

// Which child am I editing? — answered permanently, not by a chip row that scrolls away.
//
// WHY (Alan, 30 Aug 2026). The wizard's steps 4 and 5 used ChildChipRow: a row of tappable
// child chips above the sections. Two problems, both his. It is out of view the moment a
// parent scrolls into the settings they came to change — so "whose spelling reward am I
// setting?" has no answer on screen at the point the question matters. And it is the last
// place in the app still using that pattern; the rest of Parent Mode moved to
// ParentProfileSwitcher's collapsed pill.
//
// Never a switcher. The wizard walks children in sequence, so there is no wrong child to be
// on and nothing to switch between — the bar states a fact ("this is child 1 of 2, it's
// Alex") rather than offering a control that would let a parent skip a child by accident
// and finish setup with one of them unconfigured. Earnings check mounts it too, and switches
// child with the Kids tab's name pills above it (KidChips; Alan, 3 Oct); its old Switch
// button here never had a caller and went with that change.
//
// Styling deliberately borrows ParentProfileSwitcher's pill exactly (card gradient, avatar,
// white text) so the two read as the same object in two modes, not as two components.
export function ChildContextBar({ child, contextLine, index, total, sticky = true }) {
 if (!child) return null;
 const style = { background: cardGradientStyle(child.cardColor, getKidTheme(effectiveAge(child))) };
 const age = typeof child.age === "number" ? `${child.name}, ${child.age}` : child.name;
 return (
  <div className={`wizard-left ${sticky ? "sticky top-0 z-20 -mx-1 px-1 py-1 bg-slate-50" : ""}`} data-testid="child-context-bar">
   <div style={{ background: "#1B2A4A" }} className="w-full flex items-center gap-3 rounded-lg px-4 py-2.5 text-white">
    <ChildMark profile={child} size="sm" />
    <div className="min-w-0 flex-1 text-left">
     <div className="font-semibold text-base" data-testid="child-context-name">{age}</div>
     {contextLine && <div className="text-xs font-semibold text-white/85 ">{contextLine}</div>}
    </div>
    {total > 1 ? (
     <span className="font-semibold text-xs bg-white/20 rounded-full px-3 py-1.5 flex-shrink-0 whitespace-nowrap" data-testid="child-context-count">
      {ct("wizard.earn.child_count", "Child {n} of {total}", { n: index + 1, total })}
     </span>
    ) : null}
   </div>
  </div>
 );
}
